"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getImportMembershipTemplateExampleRows = exports.getImportPaymentTemplateExampleRows = exports.getImportContactTemplateExampleRows = exports.formatImportTemplateExampleDate = void 0;
const country_1 = require("../enums/country");
const dates_1 = require("../features/dates");
const EXAMPLE_DATE_PARTS = {
    date1: { day: "04", month: "01", year: "2026" },
    date2: { day: "15", month: "02", year: "2026" },
    date3: { day: "29", month: "03", year: "2026" },
    expirationDate: { day: "01", month: "09", year: "2026" },
};
const formatImportTemplateExampleDate = (country, { day, month, year }) => (0, dates_1.getDateFormatByCountry)(country).replace("dd", day).replace("MM", month).replace("yyyy", year);
exports.formatImportTemplateExampleDate = formatImportTemplateExampleDate;
const EXAMPLE_CONTACTS_BY_COUNTRY = {
    [country_1.OrganizationCountry.Canada]: [
        {
            firstName: "Emma",
            lastName: "Thompson",
            email: "emma.thompson@example.com",
            secondaryEmail: "emma.thompson@thompsonindustries.com",
            language: "EN",
            address: "123 Main Street",
            city: "Toronto",
            region: "ON",
            postalCode: "M5H 2N2",
            country: "CA",
            phone: "+1 416 555 0142",
            companyName: "Thompson Industries",
            householdName: "Thompson Family",
        },
        {
            firstName: "Jean",
            lastName: "Lavoie",
            email: "jean.lavoie@example.com",
            language: "FR",
            address: "45 rue Sainte-Catherine",
            city: "Montreal",
            region: "QC",
            postalCode: "H2X 1K5",
            country: "CA",
            householdName: "Lavoie Family",
        },
        {
            firstName: "Carlos",
            lastName: "Rivera",
            email: "carlos.rivera@example.org",
            language: "EN",
            address: "500 Market Street",
            city: "San Francisco",
            region: "CA",
            postalCode: "94105",
            country: "US",
            companyName: "Rivera Consulting",
        },
    ],
    [country_1.OrganizationCountry.UnitedStates]: [
        {
            firstName: "Emma",
            lastName: "Thompson",
            email: "emma.thompson@example.com",
            secondaryEmail: "emma.thompson@thompsonindustries.com",
            language: "EN",
            address: "500 Market Street",
            city: "San Francisco",
            region: "CA",
            postalCode: "94105",
            country: "US",
            phone: "+1 415 555 0142",
            companyName: "Thompson Industries",
            householdName: "Thompson Family",
        },
        {
            firstName: "Michael",
            lastName: "Carter",
            email: "michael.carter@example.com",
            language: "EN",
            address: "77 Beacon Street",
            city: "Boston",
            region: "MA",
            postalCode: "02108",
            country: "US",
            householdName: "Carter Family",
        },
        {
            firstName: "Carlos",
            lastName: "Rivera",
            email: "carlos.rivera@example.org",
            language: "EN",
            address: "1200 Congress Avenue",
            city: "Austin",
            region: "TX",
            postalCode: "78701",
            country: "US",
            companyName: "Rivera Consulting",
        },
    ],
    [country_1.OrganizationCountry.GreatBritain]: [
        {
            firstName: "Emma",
            lastName: "Thompson",
            email: "emma.thompson@example.com",
            secondaryEmail: "emma.thompson@thompsonindustries.com",
            language: "EN",
            address: "12 King's Road",
            city: "London",
            region: "LND",
            postalCode: "SW3 4RP",
            country: "GB",
            phone: "+44 20 7946 0142",
            companyName: "Thompson Industries",
            householdName: "Thompson Family",
        },
        {
            firstName: "Oliver",
            lastName: "Bennett",
            email: "oliver.bennett@example.com",
            language: "EN",
            address: "45 Deansgate",
            city: "Manchester",
            region: "MAN",
            postalCode: "M3 2BW",
            country: "GB",
            householdName: "Bennett Family",
        },
        {
            firstName: "Sophie",
            lastName: "Clarke",
            email: "sophie.clarke@example.org",
            language: "EN",
            address: "8 Park Street",
            city: "Bristol",
            region: "BST",
            postalCode: "BS1 5NH",
            country: "GB",
            companyName: "Clarke Consulting",
        },
    ],
    [country_1.OrganizationCountry.Ireland]: [
        {
            firstName: "Aoife",
            lastName: "Murphy",
            email: "aoife.murphy@example.com",
            secondaryEmail: "aoife.murphy@murphyindustries.ie",
            language: "EN",
            address: "12 Grafton Street",
            city: "Dublin",
            region: "D",
            postalCode: "D02 XY45",
            country: "IE",
            phone: "+353 1 555 0142",
            companyName: "Murphy Industries",
            householdName: "Murphy Family",
        },
        {
            firstName: "Cian",
            lastName: "O'Brien",
            email: "cian.obrien@example.com",
            language: "EN",
            address: "30 Patrick Street",
            city: "Cork",
            region: "CO",
            postalCode: "T12 R6TN",
            country: "IE",
            householdName: "O'Brien Family",
        },
        {
            firstName: "Niamh",
            lastName: "Kelly",
            email: "niamh.kelly@example.org",
            language: "EN",
            address: "5 Eyre Square",
            city: "Galway",
            region: "G",
            postalCode: "H91 CX34",
            country: "IE",
            companyName: "Kelly Consulting",
        },
    ],
    [country_1.OrganizationCountry.Australia]: [
        {
            firstName: "Emma",
            lastName: "Thompson",
            email: "emma.thompson@example.com",
            secondaryEmail: "emma.thompson@thompsonindustries.com",
            language: "EN",
            address: "1 Macquarie Street",
            city: "Sydney",
            region: "NSW",
            postalCode: "2000",
            country: "AU",
            phone: "+61 2 5550 0142",
            companyName: "Thompson Industries",
            householdName: "Thompson Family",
        },
        {
            firstName: "Jack",
            lastName: "Wilson",
            email: "jack.wilson@example.com",
            language: "EN",
            address: "200 Collins Street",
            city: "Melbourne",
            region: "VIC",
            postalCode: "3000",
            country: "AU",
            householdName: "Wilson Family",
        },
        {
            firstName: "Chloe",
            lastName: "Nguyen",
            email: "chloe.nguyen@example.org",
            language: "EN",
            address: "15 Queen Street",
            city: "Brisbane",
            region: "QLD",
            postalCode: "4000",
            country: "AU",
            companyName: "Nguyen Consulting",
        },
    ],
    [country_1.OrganizationCountry.NewZealand]: [
        {
            firstName: "Emma",
            lastName: "Thompson",
            email: "emma.thompson@example.com",
            secondaryEmail: "emma.thompson@thompsonindustries.com",
            language: "EN",
            address: "12 Queen Street",
            city: "Auckland",
            region: "AUK",
            postalCode: "1010",
            country: "NZ",
            phone: "+64 9 555 0142",
            companyName: "Thompson Industries",
            householdName: "Thompson Family",
        },
        {
            firstName: "Jack",
            lastName: "Wilson",
            email: "jack.wilson@example.com",
            language: "EN",
            address: "60 Willis Street",
            city: "Wellington",
            region: "WGN",
            postalCode: "6011",
            country: "NZ",
            householdName: "Wilson Family",
        },
        {
            firstName: "Chloe",
            lastName: "Nguyen",
            email: "chloe.nguyen@example.org",
            language: "EN",
            address: "100 Cashel Street",
            city: "Christchurch",
            region: "CAN",
            postalCode: "8011",
            country: "NZ",
            companyName: "Nguyen Consulting",
        },
    ],
    [country_1.OrganizationCountry.Germany]: [
        {
            firstName: "Anna",
            lastName: "Schmidt",
            email: "anna.schmidt@example.com",
            secondaryEmail: "anna.schmidt@schmidt-industrie.de",
            language: "DE",
            address: "Kaulbachstraße 12",
            city: "München",
            region: "BY",
            postalCode: "80539",
            country: "DE",
            phone: "+49 89 5550142",
            companyName: "Schmidt Industrie GmbH",
            householdName: "Familie Schmidt",
        },
        {
            firstName: "Lukas",
            lastName: "Weber",
            email: "lukas.weber@example.com",
            language: "DE",
            address: "Torstraße 45",
            city: "Berlin",
            region: "BE",
            postalCode: "10119",
            country: "DE",
            householdName: "Familie Weber",
        },
        {
            firstName: "Sofia",
            lastName: "Müller",
            email: "sofia.mueller@example.org",
            language: "DE",
            address: "Alsterufer 3",
            city: "Hamburg",
            region: "HH",
            postalCode: "20354",
            country: "DE",
            companyName: "Müller Beratung",
        },
    ],
};
const getImportContactTemplateExampleRows = (country) => {
    const [onLists, inHousehold, unsubscribed] = EXAMPLE_CONTACTS_BY_COUNTRY[country ?? country_1.OrganizationCountry.Canada];
    return [
        { ...onLists, lists: "Major donors,Volunteers", note: "Met at the 2025 Gala" },
        { ...inHousehold, lists: "Monthly donors" },
        { ...unsubscribed, subscriptionStatus: "unsubscribed" },
    ];
};
exports.getImportContactTemplateExampleRows = getImportContactTemplateExampleRows;
// Example values (names, campaign titles, payment methods) stay in English on purpose:
// Flatfile maps columns by header, and values must match what the import parser accepts.
const getImportPaymentTemplateExampleRows = (country) => {
    const dates = getExampleDates(country);
    const contacts = (0, exports.getImportContactTemplateExampleRows)(country);
    return [
        {
            ...contacts[0],
            amount: "100",
            eligibleAmount: "50",
            paymentMethod: "Cash",
            formTitle: "2025 Gala",
            rateTitle: "VIP",
            fund: "General Fund",
            date: dates.date1,
            receiptNumber: "R-2026-001",
            receiptUrl: "https://example.com/receipts/R-2026-001.pdf",
            ticketUrl: "https://example.com/tickets/1",
            annotation: "Pledged during the spring campaign",
        },
        {
            ...contacts[1],
            amount: "2400",
            paymentMethod: "Card",
            formTitle: "Donate to change lives",
            fund: "Building Fund",
            date: dates.date2,
        },
        {
            ...contacts[2],
            amount: "200",
            paymentMethod: "ACH",
            formTitle: "My membership form",
            rateTitle: "Early bird",
            date: dates.date3,
        },
    ];
};
exports.getImportPaymentTemplateExampleRows = getImportPaymentTemplateExampleRows;
// A membership example is its payment counterpart moved onto a membership campaign, plus the date it runs out.
const getImportMembershipTemplateExampleRows = (country) => {
    const [gala, monthly, earlyBird] = (0, exports.getImportPaymentTemplateExampleRows)(country);
    return [
        {
            ...gala,
            formTitle: "2025 Annual Membership",
            rateTitle: "Supporter",
            lists: "2025 donators",
            expirationDate: (0, exports.formatImportTemplateExampleDate)(country, EXAMPLE_DATE_PARTS.expirationDate),
        },
        { ...monthly, formTitle: "2025 Annual Membership", lists: "2025 donators" },
        { ...earlyBird, formTitle: "Friends Circle" },
    ];
};
exports.getImportMembershipTemplateExampleRows = getImportMembershipTemplateExampleRows;
const getExampleDates = (country) => ({
    date1: (0, exports.formatImportTemplateExampleDate)(country, EXAMPLE_DATE_PARTS.date1),
    date2: (0, exports.formatImportTemplateExampleDate)(country, EXAMPLE_DATE_PARTS.date2),
    date3: (0, exports.formatImportTemplateExampleDate)(country, EXAMPLE_DATE_PARTS.date3),
});
